import dayjs, { Dayjs as DayjsT } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(duration);

export default dayjs;

export type Dayjs = DayjsT;

export function diffYearsMonths(from: Dayjs, to = dayjs.utc()) {
  const totalMonths = dayjs(to).diff(dayjs(from), 'month');
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  const parts = [];

  if (years > 0) {
    parts.push(`${years} yr`);
  }
  if (months > 0) {
    parts.push(`${months} mo`);
  }

  return parts.join(' ') || '0 mo';
}
